module.exports = __webpack_public_path__ + "img/c2132c1.png";